import { Injectable } from '@angular/core';
import { OnBoardingRequest } from '@core/models/onboarding.model';
import { APIService } from '@core/services/api.service';

@Injectable({
  providedIn: 'root'
})
export class OnboardingServiceService {

  constructor(private readonly apiService: APIService) { }
  saveOnboardingData(data: OnBoardingRequest) {
    return this.apiService.post('User/SaveOnboardingData', data);
  }
  
}
